/**
 * Générateur — Il met en ordre et/ou complète des blocs fournis pour
 * construire un programme simple.
 * Attendu ID : 245 | Niveau : 3ème | Domaine : Algorithmique (d21, O1 niv. 1)
 *
 * ⚠️ BANQUE 3e (doc muet sur ce niveau — option (a) du TODO §5). Plan
 * auto-validé 2026-07-18 : « ordonner » (remettre les blocs d'un programme
 * de calcul dans l'ordre décrit en français), « manquant » (quel bloc
 * manque pour que le script trace un carré / calcule juste, QCM).
 */

import { randomChoice, randInt, makeQcm, makeOrdonner } from '../../../utils';

const ATTENDU_ID = 245;
const L_ORDONNER = 'Remettre les blocs dans l\'ordre';
const L_MANQUANT = 'Le bloc manquant';
const opts = (label) => ({ niveau: '3eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// ═════════ « ordonner » ═════════

const genOrdonner = () => {
    const a = randInt(2, 5);
    const b = randInt(3, 12);
    const blocs = [
        'quand le drapeau vert est cliqué',
        'demander un nombre',
        `multiplier le nombre par ${a}`,
        `ajouter ${b} au résultat`,
        'dire le résultat',
    ];
    const payload = makeOrdonner(blocs,
        `<p>Le professeur fournit les blocs d'un programme de calcul, en désordre : le programme doit `
        + `démarrer au drapeau vert, demander un nombre, le multiplier par ${a}, ajouter ${b} au résultat, `
        + 'puis dire le résultat.</p>'
        + '<p><b>Remets les blocs dans l\'ordre du programme.</b></p>',
        opts(L_ORDONNER));
    payload._meta.params = { a, b };
    return payload;
};

// ═════════ « manquant » ═════════

const genManquantQcm = () => {
    if (randInt(0, 1) === 1) {
        const c = randInt(3, 20) * 10;
        const correct = 'tourner ↻ de 90 degrés';
        const payload = makeQcm([correct, 'tourner ↻ de 60 degrés', `avancer de ${c}`, 'tourner ↻ de 45 degrés'], correct,
            `<p>Script : répéter 4 fois [avancer de ${c} ; <b>…</b>]. Le script doit tracer un CARRÉ de côté ${c}.</p>`
            + '<p><b>Quel bloc manque à la place des pointillés ?</b></p>',
            opts(L_MANQUANT));
        payload._meta.params = { variante: 'carre', c };
        return payload;
    }
    const a = randInt(2, 9);
    const correct = 'demander un nombre';
    const payload = makeQcm([correct, 'dire le résultat', `multiplier par ${a}`, 'attendre 1 seconde'], correct,
        `<p>Script : quand le drapeau vert est cliqué ; <b>…</b> ; multiplier le nombre par ${a} ; `
        + 'dire le résultat. Sans le bloc manquant, le programme n\'a RIEN à multiplier.</p>'
        + '<p><b>Quel bloc manque à la place des pointillés ?</b></p>',
        opts(L_MANQUANT));
    payload._meta.params = { variante: 'calcul', a };
    return payload;
};

const GENERATORS = {
    blocs_ordonner: genOrdonner,
    manquant_qcm_unique: genManquantQcm,
};
const FORMAT_LABELS = { ordonner: 'Ordonner', qcm_unique: 'QCM' };
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter(k => k.startsWith(`${prefix}_`))
        .map(k => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));
export const CATEGORIES = [
    { id: 'blocs', label: L_ORDONNER, formatsList: buildFormats('blocs') },
    { id: 'manquant', label: L_MANQUANT, formatsList: buildFormats('manquant') },
];
export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter(k => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
